// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__tnfaY","actionsCol":"EnrolledClinics_actionsCol__21MQt"};